import React from 'react';
import { t } from 'ttag';

export default function Price({ value }) {
    // TODO: determine separator by locale
    const thousandsSeparator = '.';
    const price = Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);
    return <React.Fragment>{price}&nbsp;{t`EUR`}</React.Fragment>;
}
